import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('TRIVIA');

export const SETUP = ActionType.simple('SETUP');
export const CLEAR = ActionType.simple('CLEAR');
export const LOAD = ActionType.RSAA('LOAD');
export const LOAD_ANSWER = ActionType.RSAA('LOAD_ANSWER');
export const LOAD_SCORE = ActionType.RSAA('LOAD_SCORE');
export const FETCH_RANKING_POSITION = ActionType.RSAA('FETCH_RANKING_POSITION');
export const SELECT_CHOICE = ActionType.simple('SELECT_CHOICE');
export const REVEAL = ActionType.simple('REVEAL');

export const LOAD_LEADERBOARD = ActionType.simple('LOAD_LEADERBOARD');
